import { useEffect, useState } from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';

import useConfig from 'hooks/useConfig';
import { CuredApiPaths } from 'models/enums';

const ViewEmailPage = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('t');

    const {
        config: { API_URL },
    } = useConfig();

    const [html, setHtml] = useState<string>(null);
    const [isLoading, setIsLoading] = useState(!!token);
    const [isError, setIsError] = useState(!token);

    useEffect(() => {
        if (!token || !API_URL) return;

        axios
            .get(`${API_URL.replace(/\/$/, '')}/${CuredApiPaths.VIEW_EMAIL}`, {
                params: { t: token },
                responseType: 'text',
            })
            .then((res) => setHtml(res.data))
            .catch(() => setIsError(true))
            .finally(() => setIsLoading(false));
    }, [token, API_URL]);

    if (isLoading) {
        return (
            <Box
                data-testid="view-email-loading"
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
            >
                <CircularProgress aria-label="Loading email" role="progressbar" />
            </Box>
        );
    }

    if (isError || !html) {
        return (
            <Box
                data-testid="view-email-not-found"
                role="main"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    gap: 2,
                    backgroundColor: 'background.default',
                }}
            >
                <Typography variant="h5" color="text.primary" fontWeight={600}>
                    Page not found
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    The link you followed is not valid.
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            component="iframe"
            data-testid="view-email-iframe"
            srcDoc={html}
            title="Email preview"
            aria-label="Email preview"
            referrerPolicy="no-referrer"
            sandbox="allow-popups"
            sx={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
        />
    );
};

export default ViewEmailPage;
